import { render } from "./panelDetails.vue?vue&type=template&id=000e0e12&scoped=true"
import script from "./panelDetails.vue?vue&type=script&lang=js"
export * from "./panelDetails.vue?vue&type=script&lang=js"

import "./panelDetails.vue?vue&type=style&index=0&id=000e0e12&lang=scss&scoped=true"

import exportComponent from "D:\\projects\\gitlab\\DemoLab\\DemoLab-data\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-000e0e12"]])

export default __exports__